import { Component, ViewChild } from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Voucher } from '../../../shared/interface';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-vouchers-backoffice',
  templateUrl: './vouchers-backoffice.component.html',
  styleUrl: './vouchers-backoffice.component.css'
})
export class VouchersBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService, private router: Router) { }

  @ViewChild("deleteVoucher") deleteVoucher!: ConfirmPopup;

  vouchers: Voucher[] = [];
  loading: boolean = false;

  ngOnInit(): void {

    this.loading = true;

    this.apiService.setVouchers();
    this.apiService.vouchersChanged.subscribe({
      next: (data) => {
        this.vouchers = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteVoucher(event: Event, voucher: Voucher) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare il voucher ${voucher.codice} del cliente ${voucher.cliente}?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteVoucher(voucher.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            this.confirmationService.close()
            this.router.navigate(['/backoffice/vouchers']);

            this.apiService.setVouchers()
            this.apiService.message("success", "Eliminazione", "Il voucher è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteVoucher() {
    this.deleteVoucher.accept();
  }

  onAnnullaDeleteVoucher() {
    this.deleteVoucher.reject();
  }


}
